import React from "react";
import cx from "classnames";
import "./Footer.css";
import { isHomeSite } from "lib/legacy";
import { SOCIAL_LINKS } from "./constants";
import ExternalLink from "components/ExternalLink/ExternalLink";
import { Stack } from "@mui/material";
import classes from "./FooterStyles.module.scss";
import { Trans } from "@lingui/macro";
import { Wrapper } from "../Wrapper/Wrapper";
import pythIcon from "img/pythIcon.svg";

type Props = { showRedirectModal?: (to: string) => void; redirectPopupTimestamp?: () => void };

export default function Footer({ showRedirectModal, redirectPopupTimestamp }: Props) {
  const isHome = isHomeSite();

  return (
    <Wrapper className={classes.component}>
      <div className={cx(classes.footerWrapper, { home: isHome })}>
        <span className={classes.copyright}>
          © {new Date().getFullYear()} <Trans>CADENCE All rights reserved</Trans>{" "}
        </span>
        <div className={classes.linksWrapper}>
            <img className={classes.pythIcon} width={80} height={50} src={pythIcon} />
        </div>
        <div className={classes.linksWrapper}>
          {SOCIAL_LINKS.map((platform) => {
            return (
              <ExternalLink key={platform.name} className={classes.socialLink} href={platform.link}>
                <img className={classes.icon} width={24} height={24} src={platform.icon} alt={platform.name} />
              </ExternalLink>
            );
          })}
        </div>
      </div>
    </Wrapper>
  );
}
